import ajax from '../http/ajax'
/**
 *
 * param {marketing_id: '', // 营销id } param
 */
export const getGoodsInfo = param => {
    return ajax.get('getGoodsInfo', param)
}
/**
 *
 * param {sstore_id: '', // 门店id
    goods_type: '', // 商品类型（proprietary:自营，agent：代理）
    goods_id: '', // 商品规格id
    spu_id: '', // 商品id} param
 */
export const getGoodsSpecList = param => {
    return ajax.get('getGoodsSpecList', param)
}
